import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import HomePageMain from './pages/home_page/main/home_page';
import LoginPageMain from './pages/login_page/main/login_page';
import SignUpPageMain from './pages/signup/main/sign_up_page';
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import APIMain from './pages/dashboard/api_page/main/api_main';
import AdminMain from './pages/dashboard/admin_page/main/admin_main';
import SignUpPage from './pages/SignUpPage';
import TermsOfServicePage from './pages/terms_of_service_page';
import PrivacyPolicyPage from './pages/privacy_policy_page';
import PrivacyPage from './pages/home_page/legal/privacy_page';
import TermsPage from './pages/home_page/legal/term_page';
import './App.css';

function App() {
  return (
    <div className="App">
    {/*<h1>
        Hello World
      </h1>
      <p>Element to center as well</p>*/}
     { <Router>
        <Routes>
          <Route path="/" element={<HomePageMain />} />
          <Route path="/login" element={<LoginPageMain />} />
          <Route path="/signup" element={<SignUpPageMain />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/api_dashboard" element={<APIMain />} />
          <Route path="/admin_dashboard" element={<AdminMain />} />
          <Route path="/terms_of_service" element={<TermsPage />} />
          <Route path="/privacy_policy" element={<PrivacyPage />} />
        </Routes>
      </Router>}
    </div>
  );
}

export default App;
